import { useEffect } from 'react'

export function useLeaveConfirmation(enabled = true) {
    useEffect(() => {
        if (!enabled) return

        const handleBeforeUnload = e => e.preventDefault()

        const handlePopState = () => {
            const confirmed = window.confirm('هل أنت متأكد أنك تريد مغادرة هذه الصفحة؟')

            if (!confirmed) {
                window.history.pushState(null, '', window.location.href)
            }
        }

        window.history.pushState(null, '', window.location.href)

        window.addEventListener('beforeunload', handleBeforeUnload)
        window.addEventListener('popstate', handlePopState)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
            window.removeEventListener('popstate', handlePopState)
        }
    }, [enabled])
}
